import Vue from 'vue'
import moment from "moment";


Vue.filter('toCurrency', function (value, currency) {

    if (typeof value !== "number") {
        return value;
    }

    let formatted = new Intl.NumberFormat('en-EN', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2
    }).format(value);

    return formatted.split(',').join(' ').replace('.', ',');
})

Vue.filter('formatDate', function(value) {

    if (value) {
        return moment(new Date(String(value))).format('DD.MM.YYYY')
    }

})
